jQuery(document).ready(function ($) {

        $('.slick-inline').slick({
            prevArrow: '<button type="button" class="slick-prev"><svg class="icon icon-fa icon-fa-chevron-left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!-- Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="icon icon-fa icon-fa-chevron-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!-- Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"/></svg></button>'
        });
        $('.carousel-tabs-section-widget ul.tabs li.tab label').click(function () {
            var thisTabNumber = $(this).attr('data-tab-number');
            var thisCarousel = $(this).closest('.tabs-group').find('.tab-content.tab-content-' + thisTabNumber + ' .slick-inline');
            if ($(thisCarousel).hasClass('needs-slick-re-init')) {
                $(thisCarousel).slick('unslick');
                $(thisCarousel).slick();
                $(thisCarousel).removeClass('needs-slick-re-init');
            }
        });
        $('.carousel-tabs-section-widget .tab-content > h3 > label').click(function () {
            var thisCarousel = $(this).closest('.tab-content').find('.slick-inline');
            if ($(thisCarousel).hasClass('needs-slick-re-init')) {
                $(thisCarousel).slick('unslick');
                $(thisCarousel).slick();
                $(thisCarousel).removeClass('needs-slick-re-init');
            }
        });
    

    $('.c2e img').each(function(){
        var thisImgSrc = $(this).attr('src');
        $(this).wrap('<a href="' + thisImgSrc + '" class="c2e-link"></a>');
        if($(this).closest('.c2e').hasClass('with-tag')){
            $('<span class="c2e-text">+ CLICK TO ZOOM</span>').insertAfter($(this));
        }
    });

        $("a.c2e-link").colorbox({maxWidth:'95%',maxHeight:'95%'});

    /* Begin: Maps Widget Scripts */
    $('.mapswidget .mapswidget-block-content').click(function(){
        $(this).closest('.mapswidget').find('.mapswidget-js-item').removeClass('active');
        var desiredLocation = $(this).attr('data-id');
        $(this).addClass('active');
        $(this).closest('.mapswidget').find('.mapswidget-map-code[data-id="'+ desiredLocation + '"]').addClass('active');
    });
    /* End: Maps Widget Scripts */


	/* scrollView usage */
	/*
	$('#your-link').click(function (event) {
		event.preventDefault();
		$('#your-div').scrollView();
	});
	*/
	$.fn.scrollView = function () {
		return this.each(function () {
			$('html, body').animate({
				scrollTop: $(this).offset().top - ($('.shopify-section-header-sticky').height() || 0)
			}, 1000);
		});
	}





    /* Begin: Detect Hash in URL */
    if(window.location.hash) {
        var thisHash = window.location.hash.replace('#','');
        $('#target-' + thisHash).scrollView();
    }
    /* End: Detect Hash in URL */

});

